import React from "react"

export default (props) => {
  return (
    <svg
      className={props.customClassName}
      {...props}
      viewBox="0 0 117 117"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Cross" transform="translate(2.5 2.5)">
        <path
          d="M0 0L111 111"
          id="Line"
          fill="none"
          stroke="#616161"
          strokeWidth="5"
        />
        <path
          d="M111 0L0 111"
          transform="translate(1 0)"
          id="Line-2"
          fill="none"
          stroke="#616161"
          strokeWidth="5"
        />
      </g>
    </svg>
  )
}
